import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FieldBindingsProvider } from '../hooks/useFieldBindings';
import { useAuth } from '../contexts/AuthContext';
import CgmModeSwitcher from './CgmModeSwitcher';
import { useCgmDisplayMode } from '../contexts/CgmDisplayModeContext';

const CgmPageFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const { t } = useTranslation('nav');
  const { mode } = useCgmDisplayMode();

  return (
    <FieldBindingsProvider key={JSON.stringify([user?.org_id, user?.id])}><div className="space-y-4" data-cgm-display-mode={mode}>
      <div className="flex flex-wrap items-center justify-end gap-3" data-testid="cgm-display-mode-row">
        {mode === 'expert' && <NavLink to="/programming" className="rounded-xl border px-3 py-2 text-sm">{t('nav:programming')}</NavLink>}
        <CgmModeSwitcher />
      </div>
      {children}
    </div></FieldBindingsProvider>
  );
};

export default CgmPageFrame;
